module.exports = __webpack_public_path__ + "static/pasport_savings_vklada-2df2dcb07d5b2deb28e065fc9c61bf1e.pdf";